import { useFetch, useListener } from "@hyper-fetch/react";

import { sdk, socketSdk } from "@/api/sdk";
import { NavCountBadge } from "@/components/layouts/page/sidebar/components/nav-count-badge";
import { m } from "@/paraglide/messages.js";

/** Unread notifications on the menu's "Notifications" pill. Reading one invalidates the count. */
export function UnreadNavBadge() {
  const unread = useFetch(sdk.notifications.unreadCount.$get);
  const incoming = useListener(socketSdk.notification.new.$listener);
  incoming.onEvent(() => {
    unread.refetch();
  });

  const count = Number(unread.data?.unreadCount) || 0;
  return <NavCountBadge count={count} label={m.notifications_nav_badge({ count: String(count) })} />;
}
